import React from "react";
import { Bell } from "lucide-react";
import useGlobalStore, {
  selectShowNotificationBellBadge,
} from "@/hooks/stores/useGlobalStore";

const NotificationBell = ({
  size = 24,
  className = "",
  staticBadge = false,
}) => {
  const bellUnreadVisible = useGlobalStore(selectShowNotificationBellBadge);
  const showBadge = staticBadge || bellUnreadVisible;

  return (
    <div
      className={`relative inline-flex items-center text-muted-foreground ${className}`}
    >
      <Bell size={size} className="text-current" />
      {showBadge && (
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500 border-2 border-card" />
        </span>
      )}
    </div>
  );
};

export default NotificationBell;
